import Vue from 'vue'
import App from './App.vue'
import router from '@/router.js'
import store from './store/store'
import Notifications from 'vue-notification'
import VueRouter from 'vue-router'
import vSelect from 'vue-select'
import VueTour from 'vue-tour'

Vue.config.productionTip = false

Vue.use(Notifications)
Vue.use(VueRouter)
Vue.use(VueTour)

Vue.component('v-select', vSelect)

// Creates a globally accessible component 'v-style' which
// is used to dynamically create css classes with data binding.
Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
